/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';

import {Observable} from 'rxjs';
import {ExternalImportRemoval} from '../_models/external-import-removal';
import {QueryParams, QueryParamsHelper} from '../_helpers/query-params.helper';
import {RemovalImportType} from '../_forms/removal-import-type';
import {ValidateExternalImportType} from '../_forms/validate-external-import-type';
import {Removal} from '../_models/removal';
import {AbstractService, RESPONSE} from './abstract.service';

@Injectable()
export class ExternalImportRemovalService extends AbstractService<ExternalImportRemoval> {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(@Inject(LOCALE_ID) public locale: string, protected httpClient: HttpClient) {
    super(locale, httpClient, 'external-import-removal', 'external-import-removals');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                              DELETE                                                                ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public deleteById(id: number, qp?: QueryParams): Observable<HttpResponse<any>> {
    return this.httpClient.delete<any>(`${this.singleUrl}/${id}`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                               PATCH                                                                ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public confirm(id: number, body: ValidateExternalImportType, qp?: QueryParams): Observable<HttpResponse<Removal | string>> {
    return this.httpClient.patch<Removal>(`${this.singleUrl}/${id}/confirm`, JSON.stringify(body), {
        headers: QueryParamsHelper.getHttpHeaders(qp),
        params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
        reportProgress: false
      }
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                POST                                                                ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public create(removalImport: RemovalImportType, qp?: QueryParams): Observable<HttpResponse<ExternalImportRemoval>> {
    return this.httpClient.post<ExternalImportRemoval>(this.singleUrl, JSON.stringify(removalImport), {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

}
